import React, {useState} from 'react';
import styled from 'styled-components';
import {
	getCssSizeValue,
	getHtmlFromRedactorField,
	getItemUrl, getMapKey,
	getPaddingsClassFromData,
	isStringEmpty
} from "@/utils/utils";
import {BREAKPOINTS, colors} from "@/styles/themeSettings";
import GridContainer from "@/components/common/GridContainer";
import {getSimpleCardData} from "@/components/common/Cards";
import {useRouter} from "next/router";
import {getButtonLinkData} from "@/components/common/Buttons/Button";
import Icon from "@/components/common/Icon/Icon";
import {ICONS} from "@/constants";
import HeaderDescriptionBlock from "@/components/HeaderDescriptionBlock";
import SimpleIconButton, {
	SIMPLE_ICON_BUTTON_ANIMATIONS,
	SIMPLE_ICON_BUTTON_CLASS_NAME
} from "@/components/common/SimpleIconButton";

const TilesBeWithUsTilesWrapper = styled.div`
    width: 100%;
	display: block;
    position: relative;
	background-color: ${({theme, backgroundColor}) => theme.colors[backgroundColor]};
	//padding: ${getCssSizeValue(80, BREAKPOINTS.MOBILE)} 0 ${getCssSizeValue(60, BREAKPOINTS.MOBILE)};
	@media (min-width: ${({theme}) => theme.breakpoints[BREAKPOINTS.TABLET]}px) {
		// padding: ${getCssSizeValue(100, BREAKPOINTS.TABLET)} 0 ${getCssSizeValue(105, BREAKPOINTS.TABLET)};
	}
	@media (min-width: ${({theme}) => theme.breakpoints.desktop || 1024}px) and (orientation: landscape) {
		//padding: ${getCssSizeValue(112, BREAKPOINTS.DESKTOP)} 0;
	}
`

const SingleRowWrapper = styled(GridContainer)`
	@media (min-width: ${({theme}) => theme.breakpoints[BREAKPOINTS.DESKTOP]}px) and (orientation: landscape) {
		//margin-bottom: ${getCssSizeValue(80, BREAKPOINTS.DESKTOP)};
	}
`

const SmallTile = styled.div`
	margin-bottom: ${getCssSizeValue(16, BREAKPOINTS.MOBILE)};
	background-color: ${({theme}) => theme.colors.platinum};
	position: relative;
	display: flex;
	flex-direction: column;
	justify-content: space-between;
	height: 427px;
	cursor: pointer;
	&:hover {
		.icon-wrapper {
			transition: top 0.3s ease-in-out, left 0.3s ease-in-out, width 0.3s ease-in-out, height 0.3s ease-in-out, transform 0.3s ease-in-out;
			top: 55px;
			left: 72px;
			width: 80px;
			height: 80px;
			img {
				width: 80px;
				transition: width 0.3s ease-in-out, height 0.3s ease-in-out;
			}
		}
		.tile-desc {
			opacity: 1;
			transition: opacity 0.3s ease-in-out;
		}
	}
	
	.${SIMPLE_ICON_BUTTON_CLASS_NAME} {
		position: absolute;
		top: 0;
		right: 0;
	}

    @media (min-width: ${({theme}) => theme.breakpoints[BREAKPOINTS.DESKTOP]}px) and (orientation: landscape) {
    	margin-bottom: unset;
	}
`

const IconWrapper = styled.div`
	width: 100%;
	display: flex;
	flex-direction: column;
	justify-content: center;
	align-items: center;
	height: 100%;
	position: absolute;
	top: 50%;
	left: 50%;
	transform: translate(-50%, -50%);
	transition: all 0.3s ease-in-out;
	img {
		transition: all 0.3s ease-in-out;
		width: 180px;
	}
`

const DescriptionWrapper = styled.div`
	width: 100%;
	display: flex;
	flex-direction: column;
	justify-content: flex-end;
	align-items: flex-start;
	height: 100%;
	position: relative;
	@media (min-width: ${({theme}) => theme.breakpoints[BREAKPOINTS.DESKTOP]}px) and (orientation: landscape) {
		padding: ${getCssSizeValue(16, BREAKPOINTS.DESKTOP)} ${getCssSizeValue(32, BREAKPOINTS.DESKTOP)} ${getCssSizeValue(16, BREAKPOINTS.DESKTOP)};
	}
	.tile-desc {
		opacity: 0;
		transition: opacity 0.3s ease-in-out;
	}
`

const BottomBarWithTitle = styled.div`
	width: 100%;
	background-color: ${({theme}) => theme.colors.richBlue};
	color: ${({theme}) => theme.colors.whiteSmoke};
	display: flex;
	flex-direction: column;
	justify-content: center;
	min-height: 80px;
    padding: ${getCssSizeValue(12, BREAKPOINTS.MOBILE)} ${getCssSizeValue(16, BREAKPOINTS.MOBILE)} ${getCssSizeValue(16, BREAKPOINTS.MOBILE)};
	@media (min-width: ${({theme}) => theme.breakpoints[BREAKPOINTS.DESKTOP]}px) and (orientation: landscape) {
		padding: ${getCssSizeValue(16, BREAKPOINTS.DESKTOP)} ${getCssSizeValue(32, BREAKPOINTS.DESKTOP)} ${getCssSizeValue(16, BREAKPOINTS.DESKTOP)};
		top: 0;
		right: 0;
	}
`

const BigTile = styled.div`
	height: 427px;
	position: relative;
	background-color: ${({theme}) => theme.colors.white};
	transition: background-color 0.3s ease-in-out;
	border: 1px solid ${({theme}) => theme.colors.richBlack};
	display: flex;
	flex-direction: column;
	justify-content: center;
	align-items: flex-start;
	cursor: pointer;
	@media (min-width: ${({theme}) => theme.breakpoints[BREAKPOINTS.DESKTOP]}px) and (orientation: landscape) {
		padding: ${getCssSizeValue(56, BREAKPOINTS.DESKTOP)}; ${getCssSizeValue(48, BREAKPOINTS.DESKTOP)};
		row-gap: ${getCssSizeValue(16, BREAKPOINTS.DESKTOP)};
	}
	&:hover {
		transition: background-color 0.3s ease-in-out;
		background-color: ${({theme}) => theme.colors.periwinkle};
		svg {
			transform: rotate(0);
			transition: transform 0.3s ease-in-out;
		}
	}
`

const CornerButton = styled.div`
    --size: ${getCssSizeValue(42, BREAKPOINTS.MOBILE)};
	--svg-size: ${getCssSizeValue(16, BREAKPOINTS.MOBILE)};
	width: var(--size);
	height: var(--size);
	background: ${({ theme }) => theme.colors.chilliRed};
	position: absolute;
	top: 0;
	right: 0;

    cursor: pointer;
	display: grid;
	place-items: center;
    svg{
		width: var(--svg-size);
		height: var(--svg-size);
		transform: rotate(-45deg);
        path,circle{
            fill: ${({theme}) => theme.colors.platinum};
        }
    }

    @media (min-width: ${({theme}) => theme.breakpoints[BREAKPOINTS.DESKTOP]}px) and (orientation: landscape) {
        --size: ${getCssSizeValue(40)};
        --svg-size: ${getCssSizeValue(24)};
	}
`

const Index = ({data, paddings, headerDescription}) => {
	const beWithUsRows = data?.beWithUsRows || [];
	const beWithUsRowsArray = [beWithUsRows]
	const router = useRouter();
	const paddingsClassName = getPaddingsClassFromData(paddings);
	const [hoveredIndex, setHoveredIndex] = useState(null)

	const handleResetHoveredIndex = () => {
		setHoveredIndex(null)
	}

	const handleHoverTile = (index) => {
		setHoveredIndex(index)
	}

	return (
		<TilesBeWithUsTilesWrapper className={paddingsClassName}>
			{headerDescription && <HeaderDescriptionBlock headerDescription={headerDescription} />}
			{beWithUsRowsArray.map((item, index) => {
				const whiteTileHeader = item?.whiteTileHeader || '';
				const whiteTileDescription = item?.whiteTileDescription || '';
				const beWithUsLinks = item?.beWithUsLinks || [];
				const smallItemsNumber = beWithUsLinks?.length || 1;
				const columnStart = parseInt(item?.columnStart || '1');
				const button = item?.button || '';
				const { url } = getButtonLinkData(button);
				return (
					<SingleRowWrapper key={getMapKey(item, index)} className={`indent-desktop-${columnStart - 1}`}>
						{beWithUsLinks.map((el, index) => {
							const href = getItemUrl(el);
							const {header, description, cover} = getSimpleCardData(el, router.locale);
							return (
								<SmallTile onClick={() => router.push(href)} className='col-desktop-4 col-mobile-8' key={header} onMouseEnter={() => handleHoverTile(index)} onMouseLeave={handleResetHoveredIndex}>
									<DescriptionWrapper>
										<IconWrapper className='icon-wrapper'>
											<img className="icon2" src={cover?.url || ''} alt={cover?.alt || ''}/>
										</IconWrapper>
										<div className='tile-desc typo-strawford typo-strawford-11'
											 dangerouslySetInnerHTML={description}/>
									</DescriptionWrapper>
									<SimpleIconButton
										color={colors.richBlack}
										rotation={135}
										animation={hoveredIndex === index ? SIMPLE_ICON_BUTTON_ANIMATIONS.ROTATE_45 : null}
									/>
									<BottomBarWithTitle className='typo-borna'>{header}</BottomBarWithTitle>
								</SmallTile>
							)
						})
						}
						{ !isStringEmpty(url) && (
							<BigTile onClick={() => router.push(url)} className={`${smallItemsNumber >= 3 ? 'col-desktop-4 col-mobile-8' : 'col-desktop-8 col-mobile-8'} `}>
								<p className='typo-borna typo-borna-10' key={whiteTileHeader}>{whiteTileHeader}</p>
								{smallItemsNumber <= 2 && <div className='typo-strawford typo-strawford-11' dangerouslySetInnerHTML={getHtmlFromRedactorField(whiteTileDescription)}/>}
								<CornerButton>
									<Icon name={ICONS.ARROW_DIAGONAL} color="white" />
								</CornerButton>
							</BigTile>
						)}
					</SingleRowWrapper>
				)
			})}
		</TilesBeWithUsTilesWrapper>
	);
};

export default Index;
